import React, { useRef } from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import OtpInput from "../OtpInput";
import { toast } from "react-toastify";
import { useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import rightTick from "../../../asset/images/rightTick-Circle.svg";
import {
  AESEncryption,
  ApiResDecrypt,
  mobileNumberEnc,
  mobileVal,
} from "../../../CommonMethhods/CommonMethods";
import axios from "axios";
import { Lead_Creation } from "../../../Configuration/API_URL";
import { useEffect } from "react";
import SmallLoader from "../../../Components/Common/smallLoader";
import { useClientContext } from "../../../context/ClientContext";
import { useResumeContext } from "../../../CommonMethhods/Context";

function IndividualMobileCard(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [otpModal, setOtpModal] = useState(false);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(30);
  const [isOtpComplete, setIsOtpComplete] = useState(false);
  const [otpValues, setOtpValues] = useState(Array(4).fill(""));
  const [otpVerified, setOtpVerified] = useState(false);
  const [checkRelation, setCheckRelation] = useState("");
  const [otpLoader, setOtpLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const relation = props?.relation;
  const inputRef = useRef(null);
  const resumeVal = props?.resumeVal?.verificationDetails;
  const activeTab = props?.activeTab
  const { selectedClient, shouldPrefill } = useClientContext();
  const { resumeHandle } = useResumeContext();
  

  const errorSchema = Yup.object().shape({
    mobileValid: Yup.string()
      .required("Mobile Number is required")
      .matches(/^[6-9]{1}[0-9]{9}$/, "Enter Valid Mobile Number"),
  });

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    setError,
    clearErrors,
    reset: resetForm,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(errorSchema),
  });

  const mobileInput = useWatch({
    control,
    name: "mobileValid",
  });

  useEffect(()=> {
    if(activeTab !== "individual"){
      clearErrors()
      setOtpVerified(false)
      setValue("mobileValid", "");
      setCheckRelation("")
      props?.setMobileVerify(false)
    } else if(shouldPrefill && selectedClient?.mobile){
      setValue("mobileValid", selectedClient?.mobile);
    }
  }, [activeTab, shouldPrefill, selectedClient]);

  const sendMobileOtp = async (data, resend) => {
    if (resend !== "true") {
      setOtpLoader(true);
    }
    let payloadValue = { mobileNo: resumeVal?.mobileNo ? resumeVal?.mobileNo : data };
    let encPayload = AESEncryption(payloadValue);
    console.log(payloadValue, "payloadValue");
    try {
      const getOtp = await axios.post(
        Lead_Creation.Send_Mobile_OTP,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getOtp?.data);

      if (res?.status === 0) {
        setOtpModal(true);
        setMinutes(0);
        setSeconds(30);
        setOtpValues(Array(4)?.fill(""));
      } else {
        setOtpModal(false);
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOtpLoader(false);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const validateMobileOtp = async () => {
    const otpString = otpValues?.join("");
    let payloadValue = { mobileNo: getValues("mobileValid"), otp: otpString };
    let encPayload = AESEncryption(payloadValue);
    try {
      const verifyOtp = await axios.post(
        Lead_Creation.Validate_Mobile_Otp,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(verifyOtp?.data);
      if (res?.status === 0) {
        if (res?.data?.isMobileNoRegistered === "YES") {
          setError("mobileValid", {
            type: "manual",
            message:
              "Mobile number is already registered with us. Please select relation to proceed.",
          });
          localStorage.setItem(
            "noAlreadyRegis",
            res?.data?.isMobileNoRegistered
          );
        } else {
          localStorage.setItem(
            "noAlreadyRegis",
            res?.data?.isMobileNoRegistered
          );
          props.setMobileVerify(true);
        }

        localStorage.setItem("IndiMobileNo", getValues("mobileValid"));
        setOtpVerified(true);
        // setNoRegistered(res?.data?.isMobileNoRegistered);
        setOtpModal(false);
        setValue("mobileValid", getValues("mobileValid"), {
          shouldValidate: true,
        });
        toast.success(res?.data?.msg);
      } else {
        toast.error(res?.message);
        setOtpValues(Array(4)?.fill(""));
        setTimeout(() => {
          document.getElementById("otp-input-0")?.focus();
        }, 100);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onHide = () => {
    setOtpModal(false);
  };

  function otpBtn() {
    sendMobileOtp(getValues("mobileValid"), "true");
  }

  const handleVerifyData = () => {
    if (otpValues?.length === 4) {
      validateMobileOtp();
    } else {
      toast.error("Please enter valid OTP");
    }
  };

  const getLeadCreation = async (mobNo) => {
    let payloadValue = {
      mobile: mobNo,
      email: "",
      source: "Comos-HNI",
      utmSource: "Individual",
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getOtp = await axios.post(
        Lead_Creation.Leade_Create,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getOtp?.data);

      if (res?.status === 0) {
        console.log(res, "resLead");
      } else {
        console.log(res?.message, "errResp");

        // toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    } 
  };

  const handleOtpComplete = (status) => {
    setIsOtpComplete(status);
  };

  const noVerified = localStorage.getItem("IndiMobileNo");
  const noAlreadyRegis = localStorage.getItem("noAlreadyRegis");
  const saveRelationVal = localStorage.getItem("saveRelationVal");

  const saveRelation = async () => {
    setSaveLoader(true);
    let payloadValue = {
      mobileNo: getValues("mobileValid"),
      emailId: "",
      relation: checkRelation,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getRelation = await axios.post(
        Lead_Creation.Save_Relation,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(getRelation?.data);
      if (res?.status === 0) {
        clearErrors("mobileValid");
        toast.success(res?.data);
        localStorage.setItem("saveRelationVal", true);
        props.setMobileVerify(true);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSaveLoader(false);
    }
  };

  const onFinalSubmit = (data) => {
    if (data?.mobileValid?.length === 10 && noAlreadyRegis === null) {
      // setSelectedClient(data?.mobileValid)
      getLeadCreation(data?.mobileValid)
      sendMobileOtp(data?.mobileValid);
    } else {
      saveRelation();
    }
  };

  useEffect(() => {
    if (noVerified?.length === 10) {
      setError("mobileValid", {
        type: "manual",
        message:
          "Mobile number is already registered with us. Please select relation to proceed.",
      });
    }else{
      clearErrors()
    }
  }, [noVerified]);

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("Text");
    const onlyNumbers = pastedData.replace(/\D/g, "");
    setValue("mobileValid", onlyNumbers, { shouldValidate: true });
  };
console.log(resumeVal?.mobileNo, noVerified, "otpVerified");

  return (
    <div className="individual-acc-card">
      <form 
      onSubmit={handleSubmit(onFinalSubmit)}
      >
        <div className="card-box">
          {saveRelationVal !== null || noAlreadyRegis === "NO" ? (
            <div className="mobile-verify-sec">
              <label className="mob-card-header">Mobile Verification</label>
              <span className="verify-text">
                Verified
                <img className="verified-success" src={rightTick} />
              </span>
            </div>
          ) : (
            <>
              <label className="mob-card-header">Mobile Verification</label>
              <div className="input-header hni-input-header">
                <label className="input-title">
                  Mobile Number<span style={{ color: "red" }}>*</span>
                </label>
                <div className="text-input">
                  <input
                    type="text"
                    placeholder="Enter mobile number"
                    className="input-st email-input"
                    autoComplete="off"
                    maxLength={10}
                    pattern="[0-9]*"
                    inputMode="numeric"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSubmit(onFinalSubmit)();
                      }
                    }}
                    // defaultValue={noVerified || resumeVal?.mobileNo}
                    defaultValue={
                      shouldPrefill ? selectedClient?.mobile || resumeVal?.mobileNo : ""
                    }
                    onKeyPress={(e) => mobileVal(e)}
                    {...register("mobileValid")}
                    onPaste={handlePaste}
                    ref={(e) => {
                      register("mobileValid").ref(e);
                      inputRef.current = e;
                    }}
                    disabled={noVerified || resumeVal?.mobileNo}
                    readOnly={otpVerified === true || noVerified?.length === 10}
                  />
                  {(noVerified || resumeVal?.mobileNo) && (
                    <span className="verify-text">
                      Verified
                      <img className="verified-success" src={rightTick} />
                    </span>
                  )}

                  <p className="forget-link add-error">
                    {errors?.mobileValid && (
                      <span>{errors?.mobileValid?.message}</span>
                    )}
                  </p>
                  {/* )} */}
                </div>
              </div>
              {(noAlreadyRegis === "YES" || noVerified?.length === 10) && (
                <div className="input-header hni-input-header">
                  <label className="input-title">
                    Select Relationship<span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="text-input">
                    <select
                      className="report-custom-select brokerage-select input-st"
                      onChange={(e) => setCheckRelation(e?.target?.value)}
                      value={checkRelation}
                    >
                      <option value="">Select</option>
                      {relation &&
                        relation.map((item) => (
                          <option value={item?.name}>{item?.name}</option>
                        ))}
                    </select>
                  </div>
                </div>
              )}

              {noVerified == null ? (
                <div className="wrap-button">
                  <button
                    type="submit"
                    className={`${
                      // getValues("mobileValid")?.length !== 10 &&
                      // noVerified?.length !== 10
                      mobileInput?.length !== 10 || mobileInput === resumeVal?.mobileNo
                        ? "disable-btn val-btn-wrap"
                        : "val-btn-wrap"
                    }`}
                    // disabled={
                    //   getValues("mobileValid")?.length !== 10 &&
                    //   noVerified?.length !== 10
                    // }
                    disabled={
                      mobileInput?.length !== 10 || mobileInput === resumeVal?.mobileNo
                    }
                  >
                    {otpLoader ? <SmallLoader /> : <>Validate</>}
                  </button>
                </div>
              ) : (
                <div className="wrap-button">
                  <button
                    type="submit"
                    className={`${
                      noVerified?.length !== 10 || checkRelation === ""
                        ? "disable-btn val-btn-wrap"
                        : "val-btn-wrap"
                    }`}
                    disabled={noVerified?.length !== 10 || checkRelation === ""}
                  >
                    {saveLoader ? <SmallLoader /> : <>Save</>}
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </form>

      <Modal
        show={otpModal}
        // onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="otp-modal setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="figure-inlac">
              {/* <h2 className="h2-css-all">Enter OTP</h2> */}
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="inactive-modal-table otp-modal-body">
            <h2 className="h2-css-all">Enter OTP</h2>
            <div className="wrap-otp-text">
              <p className="otp-text">
                A one-time password has been sent to your mobile number{" "}
                {getValues("mobileValid")?.length === 10 && (
                  <>+91 {mobileNumberEnc(getValues("mobileValid"))}</>
                )}
                <button
                  className="chang-btn"
                  onClick={() => {
                    setOtpModal(false);
                    setTimeout(() => {
                      inputRef.current?.focus();
                    }, 300);
                  }}
                >
                  Change
                </button>
              </p>
            </div>
            <OtpInput
              otpValues={otpValues}
              setOtpValues={setOtpValues}
              onVerify={handleVerifyData}
              otpBtn={otpBtn}
              seconds={seconds}
              minutes={minutes}
              onOtpComplete={handleOtpComplete}
            />

            <div className="nominee-btn-wrapper">
              <div className="wrap-button">
                <button
                  type="submit"
                  className="default-btn-wrap"
                  onClick={() => setOtpModal(false)}
                >
                  Cancel
                </button>
              </div>
              <div className="wrap-button">
                <button
                  type="submit"
                  className={`${
                    !isOtpComplete ? "disable-btn val-btn-wrap" : "val-btn-wrap"
                  }`}
                  onClick={() => handleVerifyData()}
                  disabled={!isOtpComplete}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default IndividualMobileCard;
